import $axios from 'src/utils/axios';
import IP from 'src/StoreGlobal/IP';

let companyId = parseInt(localStorage.getItem('company_id'));
let accessToken = localStorage.getItem('token');
let user_id = parseInt(localStorage.getItem('user_id'));

export const getSchedule = (projectId) => {
  // NOTE: Need to refetch values from local storage again
  let values = {
    companyId: parseInt(localStorage.getItem('company_id')) || null,
    token: localStorage.getItem('token') || null,
  };

  return $axios.get(`schedule/${values.companyId}/${projectId}`);
};

export const getCatchupRecommendation = (projectId) => {
  return $axios.get(`recommender/catch-up`, { params: { project_id: projectId, test_shift: 200 } });
};

export const getDiversionRecommendation = (projectId) => {
  return $axios.get(`recommender/diversion`, { params: { project_id: projectId } });
};

export const getCatchupWeatherRecommendation = (projectId) => {
  return $axios.get(`recommender/catch-up-project`, { params: { project_id: projectId } });
};

export const getMaterialRecommendationsList = (project_id) => {
  return $axios.get(`project/work_item/details?project_id=${project_id}`)
}

export const GetScheduleHistory = ({ project_id, page = 1, per_page = 10, search = '' }) => {
  return $axios.get(`/sow/history/list?project_id=${project_id}&page=${page}&per_page=${per_page}&search=${search}`);
}
export const GetScheduleHistoryDetails = (psow_id) => {
  return $axios.get(`/sow/work_item/details?psow_id=${psow_id}`);
}

export const getScheduleV2 = ({ project_id, start_date = '', end_date = '' }) => {
  const values = { companyId: parseInt(localStorage.getItem('company_id')) || null };
  return $axios.get(`schedule/${values.companyId}/${project_id}/v2?start_date=${start_date}&end_date=${end_date}`)
}

export const downloadGanttChartV2 = (data) => {
  return $axios.post(`project/download/gantt-chart/v2`, data)
}

export const refetchScheduleData = (data) => {
  return $axios.post(`cache_routes/refresh_cache`, data)
}